import { Box, BoxProps, styled, SxProps, Theme } from '@mui/material';
import { PlaceAutocompleteMatchedSubstring } from 'features/location';
import { forwardRef, useMemo } from 'react';

import { highlightSearchResult } from './helpers';

interface HighlightProps extends BoxProps {
    text: string;
    highlights?: string[] | PlaceAutocompleteMatchedSubstring[];
    sx?: SxProps<Theme>;
    multiline?: boolean;
}

const Highlight = forwardRef<HTMLDivElement, HighlightProps>(({ text, highlights = [], sx, ...restProps }, ref) => {
    const escapedString = useMemo(() => highlightSearchResult(text, highlights), [ text, highlights ]);

    return (
        <Root dangerouslySetInnerHTML={{ __html: escapedString }}
            sx={ sx }
            ref={ ref }
            { ...restProps }
        />
    );
});

const Root = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'multiline'
})<{ multiline?: boolean }>(({ theme, multiline }) => ({
    em: {
        backgroundColor: theme.palette.secondary.light,
        color: '#fff'
    },
    ...(multiline ? {} : {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    })
}));

export default Highlight;
